export const createDrawWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
};

export const createDrawLineRowStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
};

export const createDrawLineHeaderStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};

export const createDrawLineFieldsStyles = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: '10px',
};
